// Dashboard "Vessel Position": the stored position (AIS or set by hand), "Last seen <date time>", grey "Last known" when the
// fix is older than 6 h, and "Set position" (port name or lat / lon) for logins with Passage Plans at Edit.
// A stored position is never called live (src/lib/vesselPosition.js).
import { useState } from 'react'
import { useVesselPosition } from '../hooks/useVesselPosition'
import { positionState, lastSeenText, fmtLatLon } from '../lib/vesselPosition'
import { Segmented } from './TodoFilterBar'

const TONE = { ais: 'vp-ais', 'last-known': 'vp-stale', manual: 'vp-manual' }

export default function VesselPositionCard({ mmsi, vesselId, canSet }) {
  const { position: p, status, setManual } = useVesselPosition(mmsi, vesselId)
  const [open, setOpen] = useState(false)
  const [mode, setMode] = useState('port')
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const st = positionState(p)

  async function save(e) {
    e.preventDefault()
    if (!text.trim()) return
    setBusy(true); setErr('')
    try { await setManual(mode === 'port' ? { port: text.trim() } : { latlon: text.trim() }); setOpen(false); setText('') }
    catch (x) { setErr(x.message) }
    setBusy(false)
  }

  return (
    <div className="vp">
      <div className="vp-row">
        <span className="vp-h">Vessel Position</span>
        {p && st.state !== 'none' ? (<>
          <span className={'vp-badge ' + (st.stale ? 'vp-stale' : TONE[st.state])} title={st.state === 'ais' ? 'Position from AIS, stored ' + lastSeenText(p.ts) : undefined}>● {st.label}</span>
          <span className="vp-pos">{p.place && <b>{p.place} · </b>}{fmtLatLon(p.lat, p.lon)}</span>
          {p.source !== 'manual' && p.speed != null && <span className="vp-m">Speed <b>{Number(p.speed).toFixed(1)} kn</b></span>}
          {p.source !== 'manual' && p.course != null && <span className="vp-m">Course <b>{Math.round(p.course)}°</b></span>}
          <a className="vp-link" href={'https://www.openstreetmap.org/?mlat=' + p.lat + '&mlon=' + p.lon + '#map=11/' + p.lat + '/' + p.lon} target="_blank" rel="noreferrer">View on map ↗</a>
        </>) : status === 'loading' ? <span className="vp-m">Reading the last position…</span>
          : status === 'error' ? <span className="vp-m">Position not available just now.</span>
          : <span className="vp-m">{mmsi ? 'No AIS position received yet - the vessel may be outside AIS coverage.' : 'No MMSI set for this vessel - set the position by hand.'}</span>}
        {canSet && <button type="button" className="vp-btn" aria-expanded={open} onClick={() => { setOpen(o => !o); setErr('') }}>{open ? 'Cancel' : 'Set position'}</button>}
      </div>
      {p && st.state !== 'none' && (
        <div className="vp-seen">{lastSeenText(p.ts)}{p.source === 'manual' ? ' · set by hand' + (p.set_by ? ' by ' + p.set_by : '') + ' - an AIS fix newer than this replaces it' : st.stale ? ' · no AIS fix since - outside coverage or AIS off' : ''}</div>
      )}
      {open && (
        <form className="vp-form tdf" onSubmit={save}>
          <Segmented small label="Position by" options={[{ value: 'port', label: 'Port name' }, { value: 'latlon', label: 'Lat / lon' }]} value={mode} onChange={v => { setMode(v); setErr('') }} />
          <input className="vp-in" autoFocus aria-label={mode === 'port' ? 'Port name' : 'Latitude, longitude'} value={text} onChange={e => setText(e.target.value)}
            placeholder={mode === 'port' ? 'e.g. Antibes' : "e.g. 43.5805, 7.1281  or  43°34.8'N 7°07.7'E"} />
          <button type="submit" className="vp-btn vp-save" disabled={busy || !text.trim()}>{busy ? 'Saving…' : 'Save'}</button>
          {err && <div className="vp-err" role="alert">{err}</div>}
        </form>
      )}
    </div>
  )
}
